<div class="page-container">
  <app-toolbar [title]="'ACTIVITY_LOG.TITLE' | translate"></app-toolbar>
  <div class="page">
    <div class="activity-log">
      @if (view$ | async; as view) {
        <app-table
          [source]="source"
          [columns]="view.columns"
          [rowId]="rowId"
          [pageSize]="defaultPageSize"
          [defaultSort]="defaultSort"
          [selectable]="false"
          [syncUrl]="true"
          tableId="activity-log"
          csvFilename="activity-log"
          label="ACTIVITY_LOG.TITLE"
          rowNoun="ACTIVITY_LOG.PAGINATION.ENTRY"
          rowNounPlural="ACTIVITY_LOG.PAGINATION.ENTRIES"
        />

        <!-- Without this an empty result reads as "it never happened" rather than as "we were not
             recording it yet", which for an audit log is the more consequential of the two. -->
        <div class="coverage">
          <div class="coverage-summary">
            <mat-icon fontIcon="history"></mat-icon>
            <span>
              {{
                view.loggingSince === null
                  ? ('ACTIVITY_LOG.COVERAGE.NOTHING_RECORDED' | translate)
                  : ('ACTIVITY_LOG.COVERAGE.SUMMARY' | translate: { date: view.loggingSince })
              }}
            </span>
            @if (view.coverageRows.length > 0) {
              <button type="button" class="text-button" [attr.aria-expanded]="isCoverageOpen" (click)="isCoverageOpen = !isCoverageOpen">
                {{ (isCoverageOpen ? 'ACTIVITY_LOG.COVERAGE.HIDE' : 'ACTIVITY_LOG.COVERAGE.SHOW') | translate }}
              </button>
            }
          </div>

          @if (isCoverageOpen) {
            <table class="coverage-table" [attr.aria-label]="'ACTIVITY_LOG.COVERAGE.SHOW' | translate">
              <thead>
                <tr>
                  <th scope="col">{{ 'ACTIVITY_LOG.ACTION' | translate }}</th>
                  <th scope="col">{{ 'ACTIVITY_LOG.COVERAGE.RECORDED_SINCE' | translate }}</th>
                </tr>
              </thead>
              <tbody>
                @for (row of view.coverageRows; track row.action) {
                  <tr>
                    <td>{{ row.action }}</td>
                    <td [class.not-recorded]="row.recordedSince === null">
                      {{ row.recordedSince ?? ('ACTIVITY_LOG.COVERAGE.NOT_RECORDED_YET' | translate) }}
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          }
        </div>
      }
    </div>
  </div>
</div>
